import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function getSizePreferences(params) {
    const { baseUrl, brandId, country, clientId } = params;

    invariant(baseUrl, 'baseUrl is a required param of getUserDeatils()');
    invariant(brandId, 'brandId is a required param of getUserDetails()');
    invariant(country, 'country is a required param of getUserDetails()');
    invariant(clientId, 'clientId is a required param of getUserDetails()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/referencedata/preferences`;

    return labelRequest(authenticatedRequest(new Request(url, { headers: new Headers(headers) }), null, clientId), 'getSizePreferences');
}
